enum HttpStatusCodes {
    TooManyRequests = 429,
}

export default HttpStatusCodes;
